import { IBrandBasicForm } from './types';

export const defaultValues: IBrandBasicForm = {
  name: '',
  logoUrl: '',
  pointerUrl: '',
  status: 'Active',
  website: '',
  weight: null,
};
